import { render, staticRenderFns } from "./Accionistas.vue?vue&type=template&id=c19ef4f0&scoped=true"
import script from "./Accionistas.vue?vue&type=script&lang=js"
export * from "./Accionistas.vue?vue&type=script&lang=js"
import style0 from "./Accionistas.vue?vue&type=style&index=0&id=c19ef4f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19ef4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c19ef4f0')) {
      api.createRecord('c19ef4f0', component.options)
    } else {
      api.reload('c19ef4f0', component.options)
    }
    module.hot.accept("./Accionistas.vue?vue&type=template&id=c19ef4f0&scoped=true", function () {
      api.rerender('c19ef4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/Accionistas.vue"
export default component.exports